// 认证令牌只保存在当前页面运行时的模块闭包中。
// 页面刷新或关闭后令牌会消失，避免被 localStorage/sessionStorage 长期暴露。
let accessToken = '';
let refreshToken = '';
let generation = 0;

const legacyAuthStorageKeys = ['access_token', 'refresh_token', 'userInfo'];

const normalizeToken = token => typeof token === 'string' ? token : '';

const clearLegacyAuthStorage = () => {
  if (typeof window === 'undefined') return;

  legacyAuthStorageKeys.forEach(key => localStorage.removeItem(key));
};

const authSession = {
  getGeneration() { return generation; },
  getAccessToken() {
    return accessToken;
  },

  getRefreshToken() {
    return refreshToken;
  },

  setTokens(tokens = {}) {
    generation += 1;
    accessToken = normalizeToken(tokens.access);
    refreshToken = normalizeToken(tokens.refresh);
  },

  setAccessToken(token) {
    accessToken = normalizeToken(token);
  },

  setRefreshToken(token) {
    refreshToken = normalizeToken(token);
  },

  clear() {
    generation += 1;
    accessToken = '';
    refreshToken = '';
    clearLegacyAuthStorage();
  },
};

// 清除旧版本遗留在持久化存储中的令牌和用户信息。
clearLegacyAuthStorage();

export { clearLegacyAuthStorage };
export default authSession;
